import getBlock from './block';

const getBlockVariations = (rootState, blockId) => {
  const block = getBlock(rootState, blockId);

  if (!block || !block.variations) {
    return null;
  }

  return block.variations;
};

export default getBlockVariations;
